import { createFileRoute } from '@tanstack/react-router'
import { EmployeePoliciesTable } from '@/components/compliance/people/EmployeeComplianceSections'
import { useEmployeeCenterDashboard } from '@/components/employee-center/EmployeeCenterEmployeeShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/pending-policies',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { dashboard } = useEmployeeCenterDashboard()

  return (
    <EmployeePoliciesTable
      pendingPolicies={dashboard.pendingPolicies}
      acknowledgments={dashboard.completedAcknowledgments}
    />
  )
}
